import React, { useState } from "react";
import {
  Modal,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import FileUploader from "react-firebase-file-uploader";
import { ThreeBounce } from "better-react-spinkit";
import { compose } from "recompose";
import { connect } from "react-redux";
import { getFacilityImage, getFacility } from "src/utils/Firebase";

import styles from "./NewFacility.module.scss";

const NewFacility = ({ showFacilityModal, handleClose, facility }) => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState("");
  const [imageurl, setimageurl] = useState("");
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const handleUploadStart = () => setIsUploading(true);
  const handleProgress = progress => setProgress({ progress });
  const handleUploadError = error => {
    this.setState({ isUploading: false });
    console.error(error);
  };

  const handleUploadSuccess = filename => {
    setIsUploading(false);
    setProgress(100);
    setImage(filename);

    getFacilityImage()
      .child(filename)
      .getDownloadURL()
      .then(url => setimageurl(url));
  };

  const handleSubmit = () => {
    let facilityId = facility.data[facility.data.length - 1].id;
    if (!facilityId) {
      facilityId = 0;
    }

    const newTask = {
      id: facilityId + 1,
      title,
      content,
      imageurl
    };
    console.log(newTask, facilityId);
    getFacility()
      .child(facilityId)
      .set(newTask)
      .then(() => console.log("redirect"));
  };

  const handleChange = event => {
    const eventType = event.target.type;

    eventType === "text" && setTitle(event.target.value);

    eventType === "textarea" && setContent(event.target.value);
  };
  return (
    <Modal show={showFacilityModal} onHide={this.handleClose}>
      <Modal.Header>
        <Modal.Title>부대시설 추가하기</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        부대시설을 추가합니다.
        <form onSubmit={handleSubmit}>
          {/* 폼 입니다.*/}

          <FormGroup
            controlId="formValidationSuccess1"
            validationState="success"
          >
            <ControlLabel>제목</ControlLabel>
            <FormControl
              type="text"
              placeholder="제목"
              value={title}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup
            controlId="formValidationSuccess1"
            validationState="success"
          >
            <ControlLabel>내용</ControlLabel>
            <FormControl
              componentClass="textarea"
              placeholder="내용"
              value={content}
              className={styles.content}
              onChange={handleChange}
            />
          </FormGroup>

          <FileUploader
            accept="image/*"
            name="avatar"
            filename={file =>
              facility.data &&
              "facility" + (facility.data[facility.data.length - 1].id + 1)
            }
            storageRef={getFacilityImage()}
            onUploadStart={handleUploadStart}
            onUploadError={handleUploadError}
            onUploadSuccess={handleUploadSuccess}
            onProgress={handleProgress}
          />
          {/* for lazy load */}
          {isUploading ? (
            <div>
              <ThreeBounce size={15} color="green" />
              <p>사진이 업로드 중입니다.!</p>
            </div>
          ) : (
            <Button type="submit">업로드 하기</Button>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default compose(
  connect(({ facility }) => ({
    facility
  }))
)(NewFacility);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Facility/components/NewFacility.jsx